import script from "./P21S.vue?vue&type=script&setup=true&lang=js"
export * from "./P21S.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__